import { render, staticRenderFns } from "./details.vue?vue&type=template&id=a15f49b6&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=a15f49b6&scoped=scoped&lang=scss&"
import style1 from "./details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15f49b6",
  null
  
)

export default component.exports